import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-collect-popover',
  templateUrl: './collect-popover.component.html',
  styleUrls: ['./collect-popover.component.scss'],
})
export class CollectPopoverComponent implements OnInit {
  @Input() private popoverCtl;
  constructor() { }

  ngOnInit() {}
  close(operation) {
    this.popoverCtl.dismiss({
      operation
    });
  }
}
